import React, { FC } from 'react';
import AdhdQuestionnairePortalApp from '../../adhd/adhd-questionnaire-app';

const AdhdQuestionnairePortal: FC = () => <AdhdQuestionnairePortalApp />;

export default AdhdQuestionnairePortal;
